// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"282":"e2966c96","538":"86dfca69","738":"e2966c96","836":"5488d19e"}[chunkId] + ".css";
};